import "./src/assets/styles/global.scss"
import "./src/assets/styles/layout.styl"
import "./src/assets/styles/hamburger-menu.styl"
import "./src/assets/styles/menu-items.styl"

import React from "react"
import { StateProvider } from "./src/store"

export const wrapRootElement = ({ element }) => (
  <StateProvider>{element}</StateProvider>
)